import LensBlurSharpIcon from "@mui/icons-material/LensBlurSharp";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { type SvgIconProps } from "@mui/material/SvgIcon";
import { type FC } from "react";

export enum DashboardsTabEnum {
  HIGHLIGHTS = "highlights",
  WORLD_CUP = "world_cup",
}

export const labelByDashboardsTabEnum: Record<DashboardsTabEnum, string> = {
  [DashboardsTabEnum.HIGHLIGHTS]: "Highlights",
  [DashboardsTabEnum.WORLD_CUP]: "FIFA 2026 World Cup",
};

export const iconByDashboardsTabEnum: Record<
  DashboardsTabEnum,
  FC<SvgIconProps>
> = {
  [DashboardsTabEnum.HIGHLIGHTS]: LensBlurSharpIcon,
  [DashboardsTabEnum.WORLD_CUP]: SportsSoccerIcon,
};
